import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import Pagination from "../../Common/Pagination/Pagination";
import CountUp from "react-countup";
import { useReactToPrint } from "react-to-print";
import _ from "lodash";
// Assuming statusOrder is passed as a prop to the component
const TKCSSupplyStatus = ({ selectedDate, companyDetails }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [companyId, setCompanyId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [status, setStatus] = useState("all");
  const [pageSize, setPageSize] = useState(10);
  const [statusOrder, setStatusOrder] = useState([]);
  const [itemCount, setItemCount] = useState("");
  const [govtCountData, setGovtCountData] = useState([]);
  const [printIndex, setPrintIndex] = useState(null);
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  // const endItem = Math?.min(startItem + itemCount, totalRecords);
  const endItem = Math?.min(startItem + itemCount - 1);
  const [tkcsCountData, setTkcsCountData] = useState([]);
  const bulkPDFRef = useRef(null);
  const componentPDFRefs = useRef([]);

  const [filterCriteria, setfilterCriteria] = useState({
    party_name: "",
    po_number: "",
    di_number: "",
  });

  const handleFilterChange = (name, value) => {
    setfilterCriteria(() => {
      return {
        ...filterCriteria,
        [name]: value,
      };
    });
  };

  const handlePrint = useReactToPrint({
    content: () => componentPDFRefs.current[printIndex],
    pageStyle: `
      @page {
        size: auto !important;
      }`,
    documentTitle: "TKCS Order Status",
    onAfterPrint: () => setPrintIndex(null),
  });

  const handlePrintBulk = useReactToPrint({
    content: () => bulkPDFRef.current,
    pageStyle: `
      @page {
        size: auto !important;
      }`,
    documentTitle: "TKCS Supply Status",
    onAfterPrint: () => setPrintIndex(null),
  });
  const generatePDF = (index) => {
    setPrintIndex(index);
  };

  useEffect(() => {
    if (printIndex !== null) {
      handlePrint();
    }
  }, [printIndex]);
  const getPrivateOrderCount = async () => {
    const renewalDate = moment(selectedDate).format("YYYY-MM-DD");
    let BASE_URL =
      SERVER_URL +
      `/api/dispatch-status/private-tkcs-dispatch-status-count/${user_id}?date=${renewalDate}&companyId=${companyId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setTkcsCountData(result.data);
    } else {
      setTkcsCountData([]);
    }
  };
  useEffect(() => {
    getPrivateOrderCount();
  }, [companyId, selectedDate]);
  const getOrderStatusData = async () => {
    const currentQueryDate = moment(selectedDate).format("YYYY-MM-DD");
    const BASE_URL = `${SERVER_URL}/api/dispatch-status/private-tkcs-dispatch-status-report/${user_id}?date=${currentQueryDate}&status=${status}&companyId=${companyId}&take=${pageSize}&skip=${
      startItem - 1
    }&party_name=${filterCriteria.party_name}&po_number=${
      filterCriteria.po_number
    }&di_number=${filterCriteria.di_number}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setTotalRecords(result.total);
      setStatusOrder(result.data);
      let itemCount = 0;
      for (let i = 0; i < result.data.length; i++) {
        console.log(result.data.length);
        for (let j = 0; j < result.data[i].orderDetails.length; j++) {
          console.log(result.data[i].orderDetails.length);
          itemCount++;
        }
      }
      console.log(itemCount);
      setItemCount(itemCount);
      itemCount = 0;
    } else {
      setStatusOrder([]);
    }
  };

  useEffect(() => {
    const fecthDebounced = _.debounce(getOrderStatusData, 500);
    fecthDebounced();
    return () => {
      fecthDebounced.cancel();
    };
  }, [currentPage, pageSize, selectedDate, status, companyId, filterCriteria]);

  useEffect(() => {
    setCurrentPage(1);
  }, [status]);

  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    setCurrentPage(1); // Reset to the first page when page size changes
  };

  const handleChange = (value) => {
    setStatus(value);
  };

  const calculateTotalCostWithGST = (orderDetails) => {
    return orderDetails.reduce(
      (total, order) => total + order.cost_with_gst,
      0
    );
  };
  const handleCompanyChange = (e) => {
    setCompanyId(e.target.value);
  };

  const companyTables =
    statusOrder &&
    statusOrder?.length > 0 &&
    statusOrder?.map((company, index) => (
      <div key={index}>
        <div
          className="govt-table"
          style={{
            border: "0.05px solid lightGray",
            width: "100%",
            marginTop: "20px",
          }}
          ref={(el) => (componentPDFRefs.current[index] = el)}
        >
          <table className="table table-responsive table-bordered">
            <thead>
              <tr className="table-heads">
                <td colSpan={3}>
                  <span style={{ fontWeight: "bold" }}>Party Name: </span>
                  {company.party_name}
                </td>
                <td colSpan={5}>
                  <span style={{ fontWeight: "bold" }}>PO Number: </span>
                  {company.po_number}
                </td>
                <td colSpan={3}>
                  <span style={{ fontWeight: "bold" }}>Company Name: </span>
                  {company.company_name}
                </td>
                <td colSpan={5}>
                  <span style={{ fontWeight: "bold" }}>Products: </span>
                  <span style={{ display: "inline-flex", gap: "5px" }}>
                    {company?.product_name?.map((item, index) => (
                      <p key={index}>{item.size}</p>
                    ))}
                  </span>
                </td>
                <td>
                  <span className="print_btn">
                    <i
                      className="mdi mdi-printer-eye"
                      style={{ fontSize: "25px" }}
                      onClick={() => generatePDF(index)}
                    ></i>
                  </span>
                </td>
              </tr>
              <tr>
                <th rowSpan={2}>S.NO</th>
                <th rowSpan={2}>Product Name</th>
                <th rowSpan={2}>DI Number</th>
                <th rowSpan={2}>Invoice Qty</th>
                <th colSpan={5}>Dispatch Details</th>
                <th rowSpan={2}>Dispatch Qty</th>
                <th rowSpan={2}>Dispatch Balance</th>
                <th rowSpan={2}>Dispatch Date</th>
                <th rowSpan={2}>GP Number</th>
                <th rowSpan={2}>Invoice Date</th>
                <th rowSpan={2}>Invoice Number</th>
                <th rowSpan={2}>Vehicle Number</th>
                <th rowSpan={2}>Remarks</th>
              </tr>
              <tr>
                <th>Yard Name</th>
                <th>Company Name</th>
                <th>Dispatch Qty</th>
                <th>Opening Stock</th>
                <th>Closing Stock</th>
              </tr>
            </thead>
            <tbody>
              {company?.orderDetails?.map((detail, detailIndex) => (
                <React.Fragment key={detailIndex}>
                  {detail.dispatch_details.map((orderDetail, orderIndex) => {
                    const dispatchLen = detail.dispatch_details.length;
                    return (
                      <tr key={orderIndex}>
                        {orderIndex === 0 && (
                          <>
                            <td rowSpan={dispatchLen}>{detailIndex + 1}</td>
                            <td rowSpan={dispatchLen}>{detail.product_name}</td>
                            <td rowSpan={dispatchLen}>{detail.di_number}</td>
                            <td rowSpan={dispatchLen}>{detail.invoice_qty}</td>
                          </>
                        )}
                        <td>{orderDetail.yard_name}</td>
                        <td>{orderDetail.company_name}</td>
                        <td>{orderDetail.dispatch_qty}</td>
                        <td>{orderDetail.p_opening_stock}</td>
                        <td>{orderDetail.p_closing_stock}</td>
                        {orderIndex === 0 && (
                          <>
                            <td rowSpan={dispatchLen}>
                              {detail.total_dispatch_qty}
                            </td>
                            <td rowSpan={dispatchLen}>
                              {detail.dispatch_balance}
                            </td>
                            <td rowSpan={dispatchLen}>
                              {detail.dispatch_date}
                            </td>
                            <td rowSpan={dispatchLen}>{detail.gp_number}</td>
                            <td rowSpan={dispatchLen}>{detail.invoice_date}</td>
                            <td rowSpan={dispatchLen}>
                              {detail.invoice_number}
                            </td>
                            <td rowSpan={dispatchLen}>
                              {detail.vehicle_number}
                            </td>
                            <td rowSpan={dispatchLen}>
                              {detail.remarks ? detail.remarks : "-"}
                            </td>
                          </>
                        )}
                      </tr>
                    );
                  })}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    ));

  return (
    <>
      <div className="card mt-4">
        <div className="card-body">
          <div>
            <div
              style={{
                justifyContent: "space-between",
                display: "flex",
              }}
            >
              <p className="card-title">TKCS Orders Supply Details</p>
              <div style={{ display: "flex" }}>
                <select
                  className="form-control ml-2"
                  onChange={handleCompanyChange}
                  value={companyId}
                >
                  <option value="">Select Company (All)</option>
                  {companyDetails?.map((item, id) => {
                    return (
                      <option
                        key={id}
                        value={item.id}
                      >{`${item.companyName}, ${item.location}`}</option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="d-flex border-md-right flex-grow-1  p-3 item justify-content-center">
                  <i
                    className={`mdi mdi-dump-truck menu-icon mr-4 icon-lg dashboard-icon`}
                  ></i>
                  <div className="d-flex flex-column justify-content-around">
                    <small className="mb-1 text-muted">Total Orders</small>
                    <h2>
                      <CountUp
                        end={tkcsCountData?.activeCount}
                        duration={2}
                        separator=","
                      />
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card mt-3">
        <div className="card-body">
          <div className="status_heading">
            <div className="status_heading">
              <h5>
                TKCS Supply Status As On Date:{" "}
                {moment(selectedDate).format("DD-MM-YYYY")}
              </h5>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 d-flex flex-wrap">
              <div className="col-md-4">
                <div className="form-group flex-grow-1 me-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by party name"
                    id="party_name"
                    name="party_name"
                    onChange={(e) =>
                      handleFilterChange("party_name", e.target.value)
                    }
                    autoComplete="off"
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group flex-grow-1">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by PO number"
                    id="order_number"
                    name="po_number"
                    onChange={(e) =>
                      handleFilterChange("po_number", e.target.value)
                    }
                    autoComplete="off"
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group flex-grow-1">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by DI number"
                    id="order_number"
                    name="di_number"
                    onChange={(e) =>
                      handleFilterChange("di_number", e.target.value)
                    }
                    autoComplete="off"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="d-flex justify-content-end">
                <button
                  className="btn btn-sm btn-primary print_btn"
                  type="button"
                  disabled={
                    statusOrder && statusOrder?.length > 0 ? false : true
                  }
                  onClick={() => handlePrintBulk()}
                >
                  Print All
                  <i
                    className="mdi mdi-printer-eye"
                    style={{ fontSize: "20px" }}
                  ></i>
                </button>
              </div>
            </div>
          </div>

          <div className="private-table-container" ref={bulkPDFRef}>
            {companyTables}
          </div>
          <div style={{ marginTop: "20px" }}>
            <Pagination
              currentPage={currentPage}
              totalRecords={totalRecords}
              pageSize={pageSize}
              totalPages={totalPages}
              startItem={startItem}
              endItem={endItem}
              onPageChange={onPageChange}
              onPageSizeChange={onPageSizeChange}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default TKCSSupplyStatus;
